import React from 'react';
import { ProjectsForm } from './ProjectsForm';
import { WithQueryClient } from '../../common/WithQueryClient';
import { ProductRecommendationRenderer } from '../Products/ProductResultRenderer';

export function ProjectsFormWrapper() {
  return (
    <WithQueryClient>
      <div className="row gy-5">
        <div className="col-lg-4">
          <ProjectsForm />
        </div>

        <div className="col-lg-8">
          <ProductRecommendationRenderer formKey="PROJECTS-RECOMMENDATION-FORM" />
        </div>
      </div>
    </WithQueryClient>
  );
}
